<!-- 
Footer for pageable tables.

Allows setting the "results per page" for the table, as well as showing a second instance of the table pager.
-->
<template>
  <v-container fluid align-content-center class="paging-container pl-3 pr-2 pt-3 pb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.12);">
    <v-layout row wrap>
      <v-flex>
        <div class="our-table-footer-text mr-2">
          Showing
        </div>
        <label :for="uid + '_rowsPerPage'" class="hidden-accessible">Page number</label>
        <select 
          :id="uid + '_rowsPerPage'" :name="uid + '_rowsPerPage'" :value="paging.rowsPerPage" class="our-table-header-page-select mr-2" 
          @change="changeRowsPerPage($event.target.value)"
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <div class="our-table-footer-text">
          results per page
        </div>
      </v-flex>
      <v-spacer/>
      <v-flex class="text-xs-right">
        <table-pager :paging="paging" @update:pageNumber="$emit('update:pageNumber', $event)" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TablePager from "./TablePager.vue";

export default {
  components: { TablePager },
  props: {
    paging: {
      type: Object,
      default: null
    }
  },
  computed: {
    uid() {
      return this._uid;
    }
  },
  methods: {
    changeRowsPerPage: function(rowsPerPage) {
      var value = parseInt(rowsPerPage);
      if (value && value > 0 && value <= 100) {
        this.$emit("update:rowsPerPage", value);
      }
    }
  }
};
</script>

<style lang="scss">
.our-table-footer-text {
  cursor: default;
  display: inline-block;
  line-height: 28px;
  position: relative;
  top: 1px;
}
.our-table-header-page-select {
  position: relative;
  top: 1px;
  padding: 3px 5px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 40px;
  font-size: 13px;
}
.our-table-header-page-select:focus {
  background-color: white;
}
</style>